<!-- eslint-disable max-len -->
<template>
    <div class="wrapper">
        <div
            class="app-mask"
            :class="{'mask-slide-in': unfolded, 'mask-slide-out': !unfolded}"
            @click.stop="maskClick"
        >
        </div>
        <!-- 预览上的版本描述 -->
        <div v-if="showPreview" class="bottom-desc">
            <div class="preview-title">{{ detailInfo.version_desc }}</div>
            <div class="preview-desc-scroll">
                <div class="preview-desc">
                    <div
                        v-for="(mantle, idx) of proDescs"
                        :key="'mantle-' + idx"
                        class="preview-desc-item"
                    >
                        <span>·{{ mantle }}</span>
                    </div>
                </div>
            </div>
            <div :class="proDescs.length > 6 ? 'shadow' : ''">
                <img src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211112/1636695071616964.png" alt="">
            </div>
        </div>
        <!-- 弹层 -->
        <div
            v-loading="loading"
            class="popup-panel"
            :class="{'popup-slide-in': unfolded, 'popup-slide-out': !unfolded}"
        >
            <div class="close-icon" @click.stop="closeAction">
                <img src=" https://b.bdstatic.com/searchbox/image/cmsuploader/20211029/1635485778787705.png" alt="">
            </div>
            <!-- tab切换 -->
            <div v-if="isShowTab" class="tab center pb-show-display">
                <div
                    v-for="(tab, index) of tabs"
                    :key="tab.id"
                    :class="['tab-item', tabIndex === index ? 'tab-item-active' : '']"
                    :style="{
                        color: tabIndex === index ?
                            $root.officialHighLightFontColor : '#999999',
                    }"
                    @click="changeTab(index)"
                >
                    <span>{{ tab }}</span>
                    <div
                        v-if="tabIndex === index" class="tab-item-line"
                        :style="{
                            backgroundColor: $root.officialHighLightFontColor,
                        }"
                    >
                    </div>
                </div>
            </div>
            <!-- 一句话促销 -->
            <div
                v-if="isShowTab"
                :class="['desc', tabIndex === 0 ? 'desc-left' : 'desc-right']"
            >
                {{ productInfo.desc }}
            </div>
            <div
                class="container"
                :class="isShowTab ? 'tab-container' : 'container'"
            >
                <!-- 标题 -->
                <div :class="isShowTab ? 'tab-game-name' : 'game-name'">{{ detailInfo.title }}</div>
                <!-- 顶部信息模块 -->
                <div class="top">
                    <div
                        class="right-covers"
                        @click.stop="coversPreview(0)"
                    >
                        <img
                            :src="detailInfo.covers && detailInfo.covers[0]" alt=""
                            class="pro-img"
                        >
                        <!-- 右上角蒙层 -->
                        <div class="preview">
                            <div class="enlarge center"><img src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211101/1635736251748571.png" alt=""></div>
                        </div>
                        <div class="sold-num">
                            <div v-if="detailInfo.sold_count > 0" class="sales-num">已售{{ soldCount }}</div>
                        </div>
                    </div>
                    <div class="pro-detail">
                        <div class="price">
                            <span
                                class="yuan"
                                :style="{color: detailInfo.is_tieba_vip && detailInfo.is_show_tieba_vip_price ? '#FFD27A' : $root.officialHighLightFontColor}"
                            >￥</span>
                            <div
                                class="real-price"
                                :style="{color: detailInfo.is_tieba_vip && detailInfo.is_show_tieba_vip_price ? '#FFD27A' : $root.officialHighLightFontColor}"
                            >
                                {{ initPrice(realPrice) }}</div>
                            <img
                                v-if="detailInfo.is_tieba_vip && detailInfo.is_show_tieba_vip_price" :src="vipIcon"
                                class="vip-icon"
                            >
                            <div v-if="originalPrice" class="original-price">
                                <span>¥</span>{{ String(originalPrice).slice(0, -2) }}
                            </div>
                            <div
                                v-if="!detailInfo.is_tieba_vip && detailInfo.is_show_tieba_vip_price
                                    && detailInfo.vip_price_info.total_price !== detailInfo.normal_price_info.real_price"
                                class="tieba-vip-price"
                            >
                                <span>¥</span>{{ initPrice(detailInfo.vip_price_info.real_price) }}
                            </div>
                            <img
                                v-if="!detailInfo.is_tieba_vip && detailInfo.is_show_tieba_vip_price
                                    && detailInfo.vip_price_info.total_price !== detailInfo.normal_price_info.real_price"
                                :src="vipIcon"
                                class="vip-icon"
                            >
                        </div>
                        <div v-if="detailInfo.tab_desc && detailInfo.tab_desc.length > 0" class="discount">
                            <span class="discount-text">优惠:</span>
                            <div class="tabs">
                                <div
                                    v-for="(item, index) of detailInfo.tab_desc"
                                    :key="index"
                                    class="tab-desc"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['scroll-content', isShowTab ? 'tabScrollHeight' : 'scrollHeight']">
                    <!-- 游戏平台 -->
                    <div class="game-plat">
                        <div class="text">游戏平台</div>
                        <div class="plat-content">
                            <span
                                v-for="(plat, index) of productInfo.plat"
                                :key="plat.id"
                                :class="['plat-btn', platIndex === index ? 'plat-btn-active' : '']"
                                :style="{
                                    backgroundColor: platIndex === index ?
                                        $root.officialHighLightBtnColor : '#F7F8F9',
                                }"
                                @click="platChange(index)"
                            >
                                <div class="plat-btn-content">
                                    <span class="plat-icon">
                                        <img
                                            v-if="platIndex === index" src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211030/1635608185372805.png"
                                            alt="" class="plat-btn-icon"
                                        >
                                        <img
                                            v-else src="https://b.bdstatic.com/searchbox/image/cmsuploader/20211108/1636353510755428.png"
                                            alt="" class="plat-btn-icon"
                                        >
                                    </span>{{ plat.name }}
                                </div>
                            </span>
                        </div>
                    </div>
                    <!-- 游戏版本 -->
                    <div class="game-sku">
                        <div class="text">游戏版本</div>
                        <div class="sku-info">
                            <div
                                v-for="(type, index) of skuInfo"
                                :key="type.id"
                                :style="{
                                    backgroundColor: skuIndex === index ?
                                        $root.officialHighLightBtnColor : '#F7F8F9',
                                }"
                                :class="['sku-btn', skuIndex === index ? 'sku-btn-active' : '']"
                                @click="typeChange(index)"
                            >
                                {{ type.version_desc }}
                            </div>
                        </div>
                        <div
                            class="sku-desc"
                            :style="{
                                backgroundColor: descBackgroundColor,
                                borderColor: $root.officialHighLightFontColor,
                            }"
                        >
                            <div
                                v-for="(desc, index) of proDescs"
                                :key="index"
                                class="sku-desc-item"
                                :style="{
                                    color: $root.officialHighLightFontColor,
                                }"
                            >
                                ·{{ desc }}
                            </div>
                        </div>
                    </div>
                    <!-- 说明,售后 -->
                    <div class="act-desc">
                        <div class="act-desc-title">活动说明</div>
                        <div
                            v-for="(act, index) of actDescs"
                            :key="'act-' + index" class="act-desc-content"
                        >
                            {{ act }}
                        </div>
                        <div class="act-desc-title service">售后服务</div>
                        <div
                            v-for="(service, index) of serviceDescs"
                            :key="'service-' + index" class="service-desc-content"
                        >
                            {{ service }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="purchase-btn center">
                <div
                    class="bought-btn"
                    :style="{
                        backgroundColor: $root.officialHighLightBtnColor,
                    }"
                    @click.stop="buyGame"
                >
                    <div class="bought-text">{{ detailInfo.btn_text }}</div>
                </div>
            </div>
        </div>
        <!-- 图片预览 -->
        <div
            v-if="showPreview" class="preview-wrapper"
            @click.stop="catchMethods"
        >
            <image-preview
                :image-index="imageIndex"
                :image-list="imageList"
                @close="closePreview"
            />
        </div>
    </div>
</template>

<script>
import api from '@/api';
import {getDeepValue} from '@/utils/utility.js';
import {getQueryString, getUrlParams} from '@/utils/url';
import ImagePreview from '@/components/ImagePreview';
import {handleJumpToMidPage} from '@/utils/login';
import {openPage} from '@/utils/utility';
import vipIcon from 'public/assets/imgs/my-coupons/vip-price-tag.png';

const SPLIT_ITEM = '\n';
export default {
    components: {
        ImagePreview,
    },
    props: {
        unfolded: {
            type: Boolean,
            default: false,
        },
        appId: {
            type: String,
            default: '',
        },
        buyColor: {
            type: String,
            default: 'rgba(0,0,0,0.2)',
        },
        isLogin: {
            type: Boolean,
            default: false,
        },
        appName: {
            type: String,
            default: '',
        },
        appType: {
            type: Number,
            default: 0,
        },
        // 已购买过文案
        buyAlreadyText: {
            type: String,
            default: '',
        },
        tiebaVipStatus: {
            type: Number,
            default: 0,
        },

    },
    data() {
        return {
            tabs: ['全款预购', '定金预购'],
            tabIndex: 0,
            appBuy: {},
            productInfo: {},
            detailInfo: {},
            platIndex: 0,
            skuIndex: 0,
            // 为了取版本按钮文字
            skuInfo: {},
            // 版本描述
            proDescs: [],
            // 售后服务换行处理
            serviceDescs: [],
            // 预览图图片下标
            imageIndex: 0,
            imageList: [],
            imgList: [],
            // 是否展示预览
            showPreview: false,
            isSem: false,
            // 活动说明
            actDescs: [],
            // 初始化下标
            initIndex: 0,
            pblogData: {},
            // 是否展示tab
            isShowTab: true,
            srcId: 0,
            // activity_tab_desc: ['全款立减30','5元预约抵扣券','抽免单','抽免单','抽免单','抽免单'],
            loading: true,
            vipIcon: vipIcon,
        };
    },
    computed: {
        soldCount() {
            if (this.detailInfo.sold_count <= 0) {
                return '';
            }
            else if (this.detailInfo.sold_count >= 1 && this.detailInfo.sold_count <= 1000) {
                return this.detailInfo.sold_count;
            }
            return '1000+';

        },
        descBackgroundColor() {
            return this.$root.officialHighLightFontColor.slice(0, 7) + '33';
        },
        realPrice() {
            if (this.detailInfo.is_tieba_vip) {
                return this.detailInfo.vip_price_info.real_price;
            }
            return this.detailInfo.normal_price_info.real_price;
        },
        originalPrice() {
            if (this.detailInfo.is_tieba_vip) {
                return this.detailInfo.vip_price_info.price;
            }
            return this.detailInfo.normal_price_info.price;
        },
        hasExtra() {
            if (this.detailInfo.is_tieba_vip) {
                return this.detailInfo.vip_price_info.extra_sku.has_extra;
            }
            return this.detailInfo.normal_price_info.extra_sku.has_extra;
        },
    },
    watch: {
        unfolded(n) {
            const body = document.getElementsByTagName('body')[0];
            body.style.overflow = n ? 'hidden' : 'scroll';
            if (n) {
                this.doPanelDisplayLog();
                // tab展现打点
                this.tabDisplayLog('fullPayTab', {skuId: this.detailInfo.id, moduleName: '购买', tabName: '全款预购'});
            }
        },
        detailInfo(val) {
            this.$root.currentSkuId = val.id;
            this.$root.currentSkuInfo = val;
        },
        productInfo(val) {
            this.$root.productType = val.type;
        },
    },
    created() {
        this.isSem = Number(getQueryString('from') === 'sem');
        const {channelid} = getUrlParams();
        const {idfrom} = getUrlParams();
        const purchaseParams = {
            data: {
                app_id: this.appId,
                is_sem: this.isSem,
                channel: channelid || idfrom,
            },
        };
        api.zone.getShopSku(purchaseParams).then(appBuy => {
            this.loading = false;
            this.appBuy = appBuy;
            this.productInfo = getDeepValue(this.appBuy, 'list.0');
            this.detailInfo = getDeepValue(this.productInfo, 'plat.0.sku_list.0');
            // 用于游戏版本标题
            this.skuInfo = getDeepValue(this.productInfo, 'plat.0.sku_list');
            const proDesc = getDeepValue(this.detailInfo, 'desc');
            // 返回文案存在空格
            // proDesc && proDesc.replace(/\ +/g,"");
            const serviceDesc = getDeepValue(this.detailInfo, 'service_desc');
            const actDesc = getDeepValue(this.detailInfo, 'act_desc');
            if (proDesc) {
                this.proDescs = proDesc.split(SPLIT_ITEM);
            }
            if (actDesc) {
                this.actDescs = actDesc.split(SPLIT_ITEM);
            }
            if (serviceDesc) {
                this.serviceDescs = serviceDesc.split(SPLIT_ITEM);
            }
            this.init(this.productInfo);
            const covers = getDeepValue(this.detailInfo, 'covers');
            // 修改图片格式，数组内添加对象
            covers && this.imgProcess(covers);
            if (this.appBuy.list.length <= 1 || this.appBuy.list[this.tabIndex].plat.length === 0) {
                this.isShowTab = false;
            }
        });
    },
    methods: {
        init(productInfo) {
            const {plat, skuId} = getUrlParams();
            if (!plat || !skuId) {
                return;
            }
            let platIndex = 0;
            const that = this;
            productInfo.plat.map((item, index) => {
                if (item.name === decodeURI(plat)) {
                    platIndex = index;
                    that.platChange(index);
                }
            });
            const skuInfo = getDeepValue(productInfo, `plat.${platIndex}.sku_list`);
            skuInfo.map((item, index) => {
                if (item.id === +skuId) {
                    that.typeChange(index);
                }
            });

        },
        maskClick() {
            this.$emit('close');
            this.doClickLog('buyClose', {skuId: this.detailInfo.id, moduleName: '购买'});
        },
        closeAction() {
            this.$emit('close');
            this.doClickLog('buyClose', {moduleName: '购买'});
        },
        changeTab(index) {
            // tab切换平台和版本的第一个按钮默认高亮状态
            this.typeChange(0);
            this.platChange(0);
            this.tabIndex = index;
            this.productInfo = getDeepValue(this.appBuy, `list.${index}`);
            this.skuInfo = getDeepValue(this.productInfo, 'plat.0.sku_list');
            this.detailInfo = getDeepValue(this.productInfo, 'plat.0.sku_list.0');
            if (index === 0) {
                this.doClickLog('fullPayTab',
                                {skuId: this.detailInfo.id, moduleName: '购买', tabName: this.tabs[this.tabIndex]});
                this.tabDisplayLog('fullPayTab', {skuId: this.detailInfo.id, moduleName: '购买', tabName: '全款预购'});
            }
            else {
                this.doClickLog('depositTab',
                                {skuId: this.detailInfo.id, moduleName: '购买', tabName: this.tabs[this.tabIndex]});
                this.tabDisplayLog('depositTab', {skuId: this.detailInfo.id, moduleName: '购买', tabName: '定金预购'});
            }
        },
        platChange(index) {
            this.platIndex = index;
            this.skuIndex = 0;
            // 用于游戏版本标题
            this.skuInfo = getDeepValue(this.productInfo, `plat.${this.platIndex}.sku_list`);
            this.detailInfo = this.appBuy.list[this.tabIndex].plat[this.platIndex].sku_list[0];
            const proDesc = this.detailInfo.desc.replace(/\ +/g, '');
            const serviceDesc = this.detailInfo.service_desc;
            const actDesc  = this.detailInfo.act_desc;
            this.actDescs = actDesc.split(SPLIT_ITEM);
            this.serviceDescs = serviceDesc.split(SPLIT_ITEM);
            this.proDescs = proDesc.split(SPLIT_ITEM);
        },
        typeChange(index) {
            this.skuIndex = index;
            this.detailInfo = this.appBuy.list[this.tabIndex].plat[this.platIndex].sku_list[index];
            const proDesc = this.detailInfo.desc.replace(/\ +/g, '');
            const serviceDesc = this.detailInfo.service_desc;
            const actDesc  = this.detailInfo.act_desc;
            this.actDescs = actDesc.split(SPLIT_ITEM);
            this.serviceDescs = serviceDesc.split(SPLIT_ITEM);
            this.proDescs = proDesc.split(SPLIT_ITEM);
            // 修改图片格式，数组内添加对象
            this.imgProcess(this.detailInfo.covers);
        },
        catchMethods() {
            this.showPreview = false;
            // return;
        },
        closePreview() {
            this.showPreview = false;
        },
        coversPreview(index) {
            this.imageIndex = index;
            this.imageList = this.imgList;
            this.showPreview = true;
        },
        buyGame() {
            if (!this.isLogin) {
                handleJumpToMidPage(window.location.href);
            }
            else {
                // 有尚未完成支付的订单时，直接跳转订单列表页
                if (this.detailInfo.has_unpaid_order) {
                    openPage('orderList', getUrlParams());
                }
                else {
                    const {srcid, channelid, idfrom} = getUrlParams();
                    openPage('orderConfirm', {
                        sku_id: this.detailInfo.id,
                        app_type: this.appType,
                        app_id: this.appId,
                        app_name: this.appName,
                        srcid: srcid,
                        channelid: channelid || idfrom,
                        type: this.productInfo.type,
                        buy_flag: this.buyAlreadyText ? 1 : '',
                        buyTiebaVip: this.hasExtra && (this.tiebaVipStatus !== 0) ? 1 : 0,
                    });
                }
            }
            this.doClickLog('buyGame', {skuId: this.detailInfo.id, moduleName: '购买', btnTab: this.detailInfo.btn_text});
        },
        // 图片数据格式处理
        imgProcess(arr) {
            this.imgList = arr.map(function (obj) {
                if (arr) {
                    let robj = {url: obj};
                    return robj;
                }
            });
            return this.imgList;
        },
        doPanelDisplayLog() {
            this.$logger.display({
                value: 'module',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({
                                skuId: this.detailInfo.id,
                                module: '购买',
                            }, this.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
        },
        tabDisplayLog(tabValue, obj, pos = '') {
            let content = {
                value: tabValue,
                ext: {
                    id: '',
                    ext: Object.assign(obj, this.$root.extData),
                    pos: pos,
                },
            };
            this.$logger.display(content);
        },
        doClickLog(value, obj, pos = '') {
            let content = {
                value: value,
                ext: {
                    id: '',
                    ext: Object.assign(obj, this.$root.extData),
                    pos: pos,
                },
            };
            this.$logger.click(content);
        },
        initPrice(price) {
            const priceStr = price.toString();
            if (priceStr.slice(-2) === '00' && price !== 0) {
                return priceStr.slice(0, -2);
            }
            else if (price === 0) {
                return 0;
            }
            else if (priceStr[priceStr.length - 1] === '0') {
                return Number(price * 0.01).toFixed(1);
            }
            return Number(price * 0.01).toFixed(2);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .app-mask {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, .4);
        top: -100vh;
        left: 0;
        opacity: 0;
        z-index: 10000;
        &.mask-slide-in {
            transform: translateY(100vh);
            opacity: 1;
            transition-property: opacity, transform;
            transition-duration: 0.2s, 0s;
            transition-timing-function: linear;
            transition-delay: 0s, 0s;
        }
        &.mask-slide-out {
            transform: translateY(-100vh);
            opacity: 0;
            transition-property: opacity, transform;
            transition-duration: 0.2s, 0s;
            transition-timing-function: linear;
            transition-delay: 0s, 0.2s;
        }
    }
    .popup-panel {
        position: fixed;
        border-radius: px2rem(36) px2rem(36) 0 0;
        width: 100%;
        background: #FFF;
        left: 0;
        // top: px2rem(400);
        bottom: 0;
        z-index: 10001;
        opacity: 0;
        transform: translateY(100%);
        &.popup-slide-in {
            transform: translateY(0);
            opacity: 1;
            transition-property: opacity, transform;
            transition-duration: 0.24s, 0.32s;
            transition-timing-function: linear;
            transition-delay: 0s, 0s;
        }
        &.popup-slide-out {
            transform: translateY(100%);
            opacity: 0;
            transition-property: opacity, transform;
            transition-duration: 0.24s, 0.24s;
            transition-timing-function: linear;
            transition-delay: 0s, 0s;
        }
        .close-icon {
            img {
                width: px2rem(54);
                height: px2rem(54);
                position: absolute;
                top: px2rem(30);
                right: px2rem(30);
            }
        }
        .tab {
            margin-top: px2rem(60);
            .tab-item {
                font-size: px2rem(54);
                font-family: PingFangSC-Medium;
                height: px2rem(54);
                color: #999999;
                font-weight: 500;
                padding: 0 px2rem(55);
                position: relative;
            }
            .tab-item-active {
                font-family: PingFangSC-Medium;
                font-size: px2rem(54);
                color: #38F;
            }
            .tab-item-line {
                position: absolute;
                left: 50%;
                margin:px2rem(5) 0 0 px2rem(-25);
                width: px2rem(42);
                height: px2rem(12);
                background-color: #38F;
                border-radius: px2rem(36);
            }
        }
        .desc {
            height: px2rem(144);
            width: px2rem(1140);
            text-align: center;
            font-size: px2rem(42);
            color: #4D4D4D;
            margin: px2rem(64) px2rem(51) 0;
            line-height: px2rem(148);
        }
        .desc-left {
            background: url(https://b.bdstatic.com/searchbox/image/cmsuploader/20211029/1635490292281781.png) no-repeat;
            background-size: 100%;
        }
        .desc-right {
            background: url(https://b.bdstatic.com/searchbox/image/cmsuploader/20211029/1635490292276631.png) no-repeat;
            background-size: 100%;
        }
        .tab-container {
            padding: px2rem(0) px2rem(51) 0 px2rem(51);
        }
        .container {
            padding: px2rem(45) px2rem(51) 0 px2rem(51);
            .game-name {
                // margin上下各减去 13.5
                margin: px2rem(59) 0 px2rem(29) 0;
                font-family: PingFangSC-Medium;
                font-size: px2rem(48);
                color: #1F1F1F;
                letter-spacing: 0;
                // 为了行间距 为 27，上下 13.5
                line-height: px2rem(75);
                font-weight: 500;
            }
            .tab-game-name {
                // margin上下各减去 13.5
                margin: px2rem(0) 0 px2rem(29) 0;
                font-family: PingFangSC-Medium;
                font-size: px2rem(48);
                color: #1F1F1F;
                letter-spacing: 0;
                // 为了行间距 为 27，上下 13.5
                line-height: px2rem(75);
                font-weight: 500;
            }
            .top {
                display: flex;
                margin-bottom: px2rem(20);
                .right-covers {
                    width: px2rem(408);
                    height: px2rem(230);
                    position: relative;
                    vertical-align: middle;
                    .pro-img {
                        position: absolute;
                        top: px2rem(-5);
                        width: px2rem(408);
                        height: px2rem(230);
                        border-radius: px2rem(24);
                    }
                    .preview {
                        position: absolute;
                        top: px2rem(-5);
                        right: 0;
                        left: px2rem(344);
                        width: px2rem(64);
                        height: px2rem(64);
                        background: rgba(0,0,0,0.30);
                        border-radius: 0 px2rem(24) 0 px2rem(24);
                        .enlarge {
                            margin-top: px2rem(15);
                            img {
                                width: px2rem(34);
                                height: px2rem(34);
                            }
                        }
                    }
                    .mantle-bg {
                        width: px2rem(1242);
                        height: px2rem(2688);
                        background: rgba(0,0,0,0.90);
                        z-index: 999;
                        margin-top: px2rem(-500);
                    }
                    .sold-num {
                        position: absolute;
                        top: px2rem(110);
                        width: px2rem(408);
                        height: px2rem(115);
                        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.35) 49%, rgba(0,0,0,0.60) 100%);
                        border-radius: 0 0 px2rem(24) px2rem(24);
                    }
                    .sales-num {
                        position: absolute;
                        right: px2rem(18);
                        bottom: px2rem(18);
                        font-family: PingFangSC-Regular;
                        font-size: px2rem(33);
                        color: #fff;
                        line-height: px2rem(33);
                        text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.7);
                    }
                }
                .pro-detail {
                    width: px2rem(636);
                    flex: 1;
                    margin-left: px2rem(36);
                    .price {
                        font-family: PingFangSC-Medium;
                        line-height: px2rem(90);
                        display: flex;
                        align-items: baseline;
                        .yuan {
                            font-size: px2rem(60);
                            color: #38F;
                            line-height: px2rem(60);
                            font-weight: 500;
                        }
                        .real-price {
                            font-size: px2rem(90);
                            color: #38f;
                            line-height: px2rem(90);
                            font-weight: 500;
                        }
                        .original-price {
                            font-size: px2rem(48);
                            color: #999999;
                            line-height: px2rem(48);
                            text-decoration:line-through;
                            font-weight: 400;
                            margin: 0 18px;
                        }
                        .tieba-vip-price {
                            font-family: PingFangSC-Medium;
                            font-size: 48px;
                            color: #4D4D4D;
                            margin-right: 6px;
                            font-weight: 500;
                        }
                        .vip-icon {
                            width: 108px;
                            height: 36px;
                        }
                    }
                    .discount {
                        display: flex;
                        margin-top: px2rem(18);
                        white-space: nowrap;
                        .discount-text {
                            font-size: px2rem(33);
                            color: #4E4E4E;
                            line-height: px2rem(42);
                            margin-right: px2rem(5);
                            font-family: PingFangSC-Medium;
                        }
                        .tabs {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            width: px2rem(600);
                        }
                        .tab-desc {
                            box-sizing: border-box;
                            font-family: PingFangSC-Medium;
                            font-size: px2rem(30);
                            padding: 0 px2rem(12);
                            height: px2rem(41);
                            margin-right: px2rem(10);
                            margin-bottom: px2rem(10);
                            color: #4D4D4D;
                            line-height: px2rem(30);
                            border: px2rem(0.6) solid #4D4D4D;
                            border-radius: px2rem(50);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }
            }
            .scroll-content::-webkit-scrollbar {
                display: none;
            }
            .scroll-content {
                overflow-y: scroll;
                overflow-x: hidden;
                max-height: px2rem(640);
                padding-bottom:px2rem(51) ;
                margin-bottom: px2rem(192);
                .game-plat {
                margin-top: px2rem(54);
                .text {
                    font-size: px2rem(48);
                    color: #1F1F1F;
                    line-height: px2rem(48);
                    font-weight: 500;
                    margin-bottom: px2rem(-8);
                    font-family: PingFangSC-Medium;
                }
                .plat-btn {
                    display: inline-block;
                    width: px2rem(247);
                    height: px2rem(102);
                    background: #F7F8F9;
                    border-radius: px2rem(24);
                    font-size: px2rem(42);
                    color: #4D4D4D;
                    text-align: center;
                    line-height: px2rem(104);
                    font-weight: 500;
                    margin: px2rem(42) px2rem(42) 0 0;
                    font-family: PingFangSC-Medium;
                }
                .plat-btn:last-child {
                    margin-right: 0;
                }
                .plat-btn-active:last-child {
                    margin-right: 0;
                }
                .plat-btn-active {
                    display: inline-block;
                    width: px2rem(247);
                    height: px2rem(102);
                    background: #38F;
                    border-radius: px2rem(24);
                    font-size: px2rem(42);
                    color: #FFFFFF;
                    text-align: center;
                    line-height: px2rem(104);
                    font-weight: 500;
                    margin: px2rem(42) px2rem(42) 0 0;
                    font-family: PingFangSC-Medium;
                }
                .plat-icon {
                    display: inline-block;
                    margin-right: px2rem(20);
                    vertical-align: middle
                }
                .plat-btn-icon {
                    width: px2rem(40);
                    height: px2rem(40);
                }
            }
            .game-sku {
                margin-top: px2rem(74);
                .text {
                    font-size: px2rem(48);
                    color: #1F1F1F;
                    line-height: px2rem(48);
                    font-weight: 500;
                    margin-bottom: px2rem(-8);
                    font-family: PingFangSC-Medium;
                }
                .sku-btn {
                    display: inline-block;
                    width: auto;
                    height: px2rem(102);
                    padding: 0 px2rem(36);
                    background: #F7F8F9;
                    border-radius: px2rem(24);
                    font-size: px2rem(42);
                    color: #4D4D4D;
                    text-align: center;
                    line-height: px2rem(104);
                    font-weight: 500;
                    margin: px2rem(42) px2rem(42) 0 0;
                }
                .sku-btn:last-child {
                    margin-right: 0;
                }
                .sku-btn-active:last-child {
                    margin-right: 0;
                }
                .sku-btn-active {
                    display: inline-block;
                    width: auto;
                    height: px2rem(102);
                    padding: 0 px2rem(36);
                    background: #38F;
                    border-radius: px2rem(24);
                    font-size: px2rem(42);
                    color: #FFFFFF;
                    text-align: center;
                    line-height: px2rem(104);
                    font-weight: 500;
                    margin: px2rem(42) px2rem(42) 0 0;
                }
                .sku-desc {
                    background: rgba(69,186,188,0.08);
                    border: px2rem(2) solid #38F;
                    border-radius: px2rem(24);
                    margin-top: px2rem(36);
                    padding: px2rem(36) 0 px2rem(12) 0;
                    .sku-desc-item {
                        font-family: PingFangSC-Medium;
                        font-size: px2rem(42);
                        line-height: px2rem(62);
                        // margin-top: px2rem(-25);
                        margin: px2rem(10) 0 px2rem(10) px2rem(30);
                        color: #38F;
                        font-weight: 400;
                    }
                    .sku-desc-item:nth-of-type(1) {
                        margin-top: px2rem(-10);
                    }
                }
                .sku-desc::after {
                    opacity: 0.2;
                }
            }
            .act-desc {
                background: #F7F8F9;
                border-radius: px2rem(24);
                padding: px2rem(36) 0 px2rem(14) px2rem(30);
                margin-top: px2rem(72);
                font-family: PingFangSC-Medium;
                font-weight: 400;
                .act-desc-title {
                    margin-bottom: px2rem(24);
                    font-size: px2rem(39);
                    color: #999999;
                    line-height: px2rem(39);
                }
                .service {
                    margin-top: px2rem(26);
                }
                .act-desc-content {
                    font-size: px2rem(36);
                    color: #999999;
                    line-height: px2rem(57);
                    margin-bottom: px2rem(10);
                }
                .act-desc-content :last-child {
                    margin-bottom: px2rem(8);
                }
                .service-desc-content {
                    font-size: px2rem(36);
                    color: #999999;
                    line-height: px2rem(57);
                    margin-bottom: px2rem(10);
                }
            }
            }
            .tabScrollHeight {
                max-height: px2rem(1120);
            }
            .scrollHeight {
                max-height: px2rem(920);

            }
        }
        .purchase-btn {
                width: px2rem(1242);
                position: fixed;
                bottom: 0;
                height: px2rem(192);
                line-height: px2rem(192);
                background-color:#ffffff;
                .bought-btn {
                    width: px2rem(1140);
                    height: px2rem(132);
                    // line-height: px2rem(192);
                    border-radius: px2rem(66);
                    background-color: #38f;
                    // text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 px2rem(51);
                    .bought-text {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: px2rem(1140);
                    height: px2rem(132);
                    font-size: px2rem(54);
                    // line-height: px2rem(132);
                    color: #fff;
                    }
                }
            }
    }
    .bottom-desc {
        z-index: 10004;
        position: fixed;
        top: 70%;
        bottom: px2rem(20);
        left: px2rem(80);
        .preview-title {
            font-family: PingFangSC-Medium;
            font-size: px2rem(66);
            line-height: px2rem(66);
            color: #fff;
            font-weight: 500;
            z-index: 10004;
            margin-bottom: px2rem(49);
            }
        .preview-desc-scroll {
            max-height:70%;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .preview-desc-scroll::-webkit-scrollbar {
                display: none;
        }
        .shadow {
            z-index: 10008;
            margin-top: px2rem(-114);
            height: px2rem(114);
            img {
                height: px2rem(114);
                opacity: 99%;
                z-index: 10008;
            }
        }
        .preview-desc-item {
            font-family: PingFangSC-Medium;
            font-size: px2rem(45);
            line-height: px2rem(71);
            z-index: 10004;
            color: #ffffff;
            }
        .preview-desc-item:last-child {
            margin-bottom: px2rem(45);
        }
    }
    // 图片预览
    .preview-wrapper {
            z-index: 10002;
            width: 100vw;
            height: 100vh;
            .top {
                z-index: 9999;
            }
            .middle {
                height: 100vh !important;
                overflow: scroll;
                display: flex;
                align-items: center;
                .arrow-icon {
                    position: fixed;

                }
                img {
                    height: auto !important;
                }
            }
            .image-preview {
                z-index: 10002;
                background: #222222;
            }

    }
</style>